<template>
    <dropdown name="name" :is-a-dropdown="true" button-name="Create a new claim">
        <ul>
            <li @click="newFatalDependencyClaim">Fatal Accident Dependency</li>
            <li @click="newFatalEstateClaim">Fatal Accident Estate</li>
            <li @click="newLostClaim">Lost Years</li>
            <li @click="newPersonalClaim">Personal Injury</li>
        </ul>
    </dropdown>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import dropdown from 'components/dropdown/Dropdown.vue';

    export default {
        name: 'right-col',
        components: {
            dropdown,
        },
        computed: {
        },
        watch: {
            '$route'() {
                window.scrollTo(0, 0);
            }
        },
        methods: {
            ...mapActions('dropdown', ['toggle']),
            ...mapActions('menu', ['updateMenu', 'updateMobileMenu', 'updateSubMenu']),
            ...mapActions('fatal/dependency/claimDetails', {resetFatalDependency: 'reset'}),
            ...mapActions('fatal/estate/claimDetails', {resetFatalEstate: 'reset'}),
            ...mapActions('lost/claimant', {resetLost: 'reset'}),
            ...mapActions('personal/claimant', {resetPersonal: 'reset'}),
            ...mapActions('claim', ['reset', 'initialise']),
            newFatalDependencyClaim() {
                this.reset()
                    .then(() => {
                        this.resetFatalDependency();
                        this.updateMenu(true);
                        this.updateSubMenu('fatal/dependency');
                    })
                    .then(() => {
                        this.$router.push({name: 'fatal::dependency.step-1'});
                    });
            },
            newFatalEstateClaim() {
                this.reset()
                    .then(() => {
                        this.resetFatalEstate();
                        this.updateMenu(true);
                        this.updateSubMenu('fatal/estate');
                    })
                    .then(() => {
                        this.$router.push({name: 'fatal::estate.step-1'});
                    });
            },
            newLostClaim() {
                this.reset()
                    .then(() => {
                        this.resetLost();
                        this.updateMenu(true);
                        this.updateSubMenu('lost');
                    })
                    .then(() => {
                        this.initialise('lost_years');
                        this.$router.push({name: 'lost::step-1'});
                    });
            },
            newPersonalClaim() {
                this.reset()
                    .then(() => {
                        this.resetPersonal();
                        this.updateMenu(true);
                        this.updateSubMenu('personal');
                    })
                    .then(() => {
                        this.initialise('personal_injury');
                        this.$router.push({name: 'personal::step-1'});
                    });
            }
        },
    }
</script>



// WEBPACK FOOTER //
// CreateANewClaim.vue?056795db